/*
    Компонент для вывода информации по автомобилю для демо-формы стандартизации
    Выводит полученные в props данные,
    по готовности (при маунтинге) выполняет readyCallback, чтобы сообщить родителю о готовности
*/

const template = /* html */`
<div class="grid results-block results-block--left items-start gap-sm-1">
    <span
        class="mb-1 mb-sm-0 font-roboto-bold grid-col-span-sm-2"
    >
        Результат разбора
    </span>
    <span class="color-gray">Марка</span>
    <span class="mb-1 mb-sm-0 mt-0_25 mt-sm-0" data-ref="name">
        [[ suggestion.brand || '—' ]]
    </span>
    <span class="color-gray">Модель</span>
    <span class="mb-1 mb-sm-0 mt-0_25 mt-sm-0" data-ref="name">
        [[ suggestion.model || '—' ]]
    </span>
</div>
`;

export default {
    name: "VehicleResults",
    template,
    props: {
        suggestion: {
            type: Object,
            required: true,
        },
        readyCallback: {
            type: Function,
            default: () => {},
        },
    },
    mounted() {
        this.readyCallback();
    },
};
